import React from "react";
import Login from "../login/Login";
import Home from "../home/Home";
import Products from "../products/Products";
import Order from "../order/Order";
import ProtectedRoute from "./ProtectedRoute";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import InvalidRoute from "./InvalidRoute";
import { AppContext } from "./AppContext";
import "../../common/translations/i18n.js";

export default function App() {
  return (
    <BrowserRouter basename={window.BASENAME_URL}>
      <AppContext>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order"
            element={
              <ProtectedRoute>
                <Order />
              </ProtectedRoute>
            }
          />
          <Route 
            path="*"
            element={
              <InvalidRoute homeUrl="/home" />
            } 
          />
        </Routes>
      </AppContext>
    </BrowserRouter>
  );
}
